export const EventMap = [
  { Name: "Send Email", In: ["Event", "To", "Cc", "Subject", "Body"], Out: ["OnSend"] },
  {
    Name: "Send Approval",
    In: ["Event", "To", "Header Text", "Selection Text", "Body"],
    Out: ["OnSend"],
  },
  { Name: "Open Hyperlink", In: ["Event", "Hyperlink"], Out: ["OnOpen"] },
  { Name: "Submit Form", In: ["Event"], Out: ["OnSubmit"] },
].sort((a, b) => a.Name.localeCompare(b.Name));
